import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
import { Route, Routes, Link } from "react-router-dom";
import Axios from "axios";
import moment from "moment";
import { FieldArray, Form, Formik } from "formik";
import { Button, CircularProgress, Grid, Typography } from "@mui/material";
import FormikControl from "../../../Components/LifeInsFormikComponent/FormikControl";
import createInitialValue from "../../../Utilities/InitialValuesSetup/createInitialValue";
import * as Yup from "yup";
import { Box } from "@mui/system";

import { useNavigate, useParams } from "react-router";
import automaticValidationSchema from "../../../Utilities/ValidationSchemaSetup/automaticValidationSchema";
import Swal from "sweetalert2";
/* import AutoFillsetup from "../../../Utilities/AutoFillsetup/AutoFillsetup";
import regex from "../../../Utilities/AutoFillsetup/AutoFillsetup";
import finalreq from "../ValidateProposer/FinalReqbody";
import getbi from "../../../Utilities/AutoFillsetup/GetBibody";
import AutoFillform from "../../../Utilities/AutoFillsetup/AutoFillsetup";
import { reInitializeBI } from "../../../Utilities/LifeInsuranceRequestBodies/ReInitializeValues/reinitialize"; */
import CategoryHeader from "../../../Components/Headers/CategoryHeader";
import autoFillBiForm from "../../../Utilities/LifeInsuranceRequestBodies/AuotoFillSubProp/AutoFillBi";


function GetBiForm(props) {
  const [productDetails, setProductDetails] = useState([]);
  const [isSubmitForm, setIsSubmitForm] = useState(false);
  const [transferData, setTransferData] = useState({});
  const [savedValisate, setSavedValidate] = useState({});
  const [pdfLink, setPdfLink] = useState("");
  const navigate = useNavigate();

  const { id } = useParams();

  console.log(id);

  const productIdArray = id.split("*");
  const productRef = productIdArray[0];
  const transId = productIdArray[1];
  const validateFormid = productIdArray[2];

  console.log(transferData, "transferData");
  //console.log(productDetails, "transferData")

  var initialValues = {};

  if (
    Object.keys(productDetails).length > 0 
    &&
    Object.keys(savedValisate).length > 0
  ) {
    console.log('prod ff',productDetails)
    initialValues = createInitialValue(productDetails);
    console.log('inigt',initialValues)
  //initialValues = AutoFillform(savedValisate, initialValues);
    initialValues = autoFillBiForm(initialValues,savedValisate)
  }
  // console.log(finalIni, "final")

  var validationSchema = Yup.object().shape({});
  if (Object.keys(productDetails).length > 0) {
    validationSchema = automaticValidationSchema(
      productDetails.requestBody.formFields.fields
    );
  }

  useEffect(() => {
    let domainExpress = "";
    let domainDjango = "";

    if (window.location.hostname === "localhost") {
      domainExpress = process.env.REACT_APP_LOCAL_EXPRESS;
      domainDjango = process.env.REACT_APP_LOCAL_DJANGO;
    } else if (window.location.hostname.trim() === "acuvisor.com") {
      domainExpress = process.env.REACT_APP_PRODUCTION_EXPRESS;
      domainDjango = process.env.REACT_APP_PRODUCTION_DJANGO;
    } else {
      domainExpress = process.env.REACT_APP_UAT_EXPRESS;
      domainDjango = process.env.REACT_APP_UAT_DJANGO;
    }

    Axios.get(
      `${domainExpress}/api/v1/lifeInsurance/validate-form/${productRef}`
      //`http://localhost:3002/api/v1/lifeInsurance/validate-form/${productRef}`
    ).then((response) => {
      if (response.status === 200) {
        console.log("response from node", response);
        setProductDetails(response.data);
      }
    });

    Axios.get(
      `${domainDjango}/api/shriram/plp-validate-response/${transId}/`
    ).then((response) => {
      setTransferData(response.data);
      console.log(response, "transdata in bi");
    });

    Axios.get(
      `${domainDjango}/api/life-insurance/get-validate-proposal/${validateFormid}/`
    ).then((response) => {
      // setTransferData(response.data)
      console.log(response, "Savedvalidate ");
      setSavedValidate(response.data);
    });
  }, []);

  // const onSubmit=(values)=>{
  //   console.log("Getbi Form valies",values)
  //   console.log('ts',transferData)
  //   let id_split=id.split('+')
  // alert(Object.entries(values).map((field,index)=>{
  //      return `${field[0]}:${field[1]}`

  // }))
  // navigate(`/paypremium/${id_split[0]}`)
  // }

  const onSubmit = (values) => {
    console.log("Getbi Form valies", JSON.stringify(values));

    let domain = "";
    if (window.location.hostname === "localhost") {
      domain = process.env.REACT_APP_LOCAL_DJANGO;
    } else if (window.location.hostname.trim() === "acuvisor.com") {
      domain = process.env.REACT_APP_PRODUCTION_DJANGO;
    } else {
      domain = process.env.REACT_APP_UAT_DJANGO;
    }
    setIsSubmitForm(true);


    Axios.post(`${domain}/api/life-insurance/bi/`, values).then((response) => {
      console.log(response, "response in GETBI");
      if (response.data.ResultSet.ResponseCode === "200") {
        setIsSubmitForm(false);
        setPdfLink(response.data.ResultSet.Response.BILink);
        console.log("link", response.data.ResultSet.Response.BILink);
        let bi_link = response.data.ResultSet.Response.BILink;
        let doc = {
          "Base64file":response.data.ResultSet.Response.Base64file,
          "FileName":response.data.ResultSet.Response.FileName,
        }
        navigate(
          `/life-insurance/bi_document/${transferData.payment_config_id}*${transId}*${validateFormid}`,
          { state: { bi_link, doc } }
        );

        /*    Swal.fire({
               title: 'You can download the details by using this link',
               html:
                 `<a target="_blank" href=http://${response.data.ResultSet.Response.BILink}>${response.data.ResultSet.Response.BILink}</a> `,
     
               showDenyButton: false,
               showCancelButton: false,
               confirmButtonText: 'OK',
               denyButtonText: `Don't save`,
             }).then((result) => {
               
               if (result.isConfirmed) {
                 let id_split = id.split('+')
                 let bi_link = response.data.ResultSet.Response.BILink
                 //navigate(`/life-insurance/paypremium/${transferData.payment_config_id}*${transId}*${validateFormid}`)
                 navigate(`/life-insurance/bi_document/${transferData.payment_config_id}*${transId}*${validateFormid}`,{state:{bi_link}})
   
                 // Swal.fire('Saved!', '', 'success')
               } else if (result.isDenied) {
                 Swal.fire('Changes are not saved', '', 'info')
               }
             }) */
        //window.open(`http://${response.data.ResultSet.Response.BILink}`
      }else {
        
      }
    }).catch(e=>{
      console.log('erro',e.response)
      setIsSubmitForm(false);
      alert(e.response.data.message)
    })
  };

const handleBack=()=>{
  navigate(-1);
}

  return (
    <div id="">
      <div className="">
      <div className="">
            <CategoryHeader title="Life Insurance" />
          </div>
        <div className=" ">
          
          <h3 className="fw-400 text-center my-4 heading-text">
            Benefit Illustration
          </h3>
          {Object.keys(initialValues).length > 0 ? (
            <Formik
              enableReinitialize
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
            >
              {(formik) => {
                console.log("formik val", formik);
                return (
                  
                    <Form>
                      <div className="shadow-md rounded-card form-container ">
                      {Object.keys(productDetails).length > 0
                        ? productDetails.requestBody.formFields.fields.map(
                            (field, index) => {
                              return field.htmlElement === "TextField" ? (
                                <div
                                  className="mb-3"
                                  key={index}
                                  hidden={field.hidden}
                                >
                                  <FormikControl
                                    control="input"
                                    errors={formik.errors}
                                    name={field.name}
                                    readOnly={field.readOnly}
                                    url={field.url}
                                    label={field.label}
                                    type={field.dataType}
                                    touched={formik.touched}
                                  />
                                </div>
                              ) : field.htmlElement === "Select" ? (
                                <div
                                  className="mb-3"
                                  key={index}
                                  hidden={field.hidden}
                                >
                                  <FormikControl
                                    control="select"
                                    name={field.name}
                                    errors={formik.errors}
                                    readOnly={field.readOnly}
                                    url={field.url}
                                    options={field.options}
                                    label={field.label}
                                    type={field.dataType}
                                    touched={formik.touched}
                                  />
                                </div>
                              ) : field.htmlElement === "Radio" ? (
                                <div
                                  className="mb-3"
                                  key={index}
                                  hidden={field.hidden}
                                >
                                  <FormikControl
                                    control="radio"
                                    name={field.name}
                                    errors={formik.errors}
                                    readOnly={field.readOnly}
                                    url={field.url}
                                    label={field.label}
                                    type={field.dataType}
                                    options={field.options}
                                    touched={formik.touched}
                                  />
                                </div>
                              ): field.htmlElement === "DatePicker" ? (
                                <div
                                  className="mb-3"
                                  key={index}
                                  hidden={field.hidden}
                                  id={field.name}
                                >
                                  <FormikControl
                                    control="date"
                                    name={field.name}
                                    readOnly={field.readOnly}
                                    label={field.label}
                                    type={field.dataType}
                                    //page={page}
                                  />
                                </div>
                              )  : null;
                            }
                          )
                        : null}
</div>
                      <div className="btn-sec position-fixed bottom-0 mt-3 ">
                        
                        {isSubmitForm ? (
                          <div className="mx-auto">
                            <CircularProgress
                              size={48}
                              sx={{
                                color: "red",
                              }}
                            />
                          </div>
                        ) : (
                          <>
                             <button
                                  className="Goback_btn"
                                  type="button"
                                  onClick={handleBack}
                                >
                                  Back
                                </button>
                            <button className="submitBtn " type="submit">
                              Submit
                            </button>
                          </>
                        )}
                      </div>
                    </Form>
                  
                );
              }}
            </Formik>
          ) : (
            <Typography>Loading....</Typography>
          )}
        </div>
      </div>
    </div>
  );
}

export default GetBiForm;
